var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseFilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9987 0.333984C3.31203 0.333984 0.332031 3.31398 0.332031 7.00065C0.332031 10.6873 3.31203 13.6673 6.9987 13.6673C10.6854 13.6673 13.6654 10.6873 13.6654 7.00065C13.6654 3.31398 10.6854 0.333984 6.9987 0.333984ZM9.86536 9.86732C9.60536 10.1273 9.18536 10.1273 8.92537 9.86732L6.9987 7.94065L5.07203 9.86732C4.81203 10.1273 4.39203 10.1273 4.13203 9.86732C3.87203 9.60732 3.87203 9.18732 4.13203 8.92732L6.0587 7.00065L4.13203 5.07398C3.87203 4.81398 3.87203 4.39398 4.13203 4.13398C4.39203 3.87398 4.81203 3.87398 5.07203 4.13398L6.9987 6.06065L8.92537 4.13398C9.18536 3.87398 9.60536 3.87398 9.86536 4.13398C10.1254 4.39398 10.1254 4.81398 9.86536 5.07398L7.9387 7.00065L9.86536 8.92732C10.1187 9.18065 10.1187 9.60732 9.86536 9.86732Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilledIcon);
export default __webpack_public_path__ + "static/media/closeFilledIcon.fda4ac0bbe7514ea0fd52550f24a2a6d.svg";
export { ForwardRef as ReactComponent };